(function($, Global) {
    $.fn.gridtable = function() {
        return $(this).each(function(i) {
            var $this = $(this);
            var $inside = $this.find('.table-row > [class*="col-"] > *');
            var allHeights = [];

            if ($(window).width() >= Global.viewports.md && $inside.length > 1) {
                $inside.css({
                    'height': '100%'
                }).each(function() {
                    var insideHeight = $(this).outerHeight();
                    var childContainerHeight = $(this).find('> div.position').outerHeight(true)

                    allHeights.push((childContainerHeight && childContainerHeight > insideHeight)
                        ? childContainerHeight
                        : insideHeight);
                }).css({
                    'height': ($this.css('display') === 'block')
                        ? '100%'
                        : allHeights.sort(function(a, b) {
                            return a - b
                        }).reverse()[0]
                })
            } else {
                $inside.css({
                    'height': 'auto'
                });
            }
        });
    }
}(jQuery, window));